import Api from './baseApi';

export default {
  list: (onlyActive) => Api.get('/api/currencies', { params: { onlyActive } }),
  create: (payload) => Api.post('/api/currencies', payload),
  update: (id, payload) => Api.put(`/api/currencies/${id}`, payload),
  remove: (id) => Api.delete(`/api/currencies/${id}`),
};
